import React, { Component } from 'react';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { Subscribe } from 'unstated';
import JamRecipesCard from '../components/JamRecipesCard';
import HeaderPage from './HeaderPage';
import TemplatesContainer from '../containers/TemplatesContainer';

const styles = {
  recipesContainer: {
    margin: '0 auto',
    width: 'calc(100% - 5.625rem)',
  },
  titleWrapper: {
    marginTop: '1.5rem',
    marginBottom: '1.5rem',
  },
  title: {
    fontFamily: 'Lato',
    fontSize: '1.75rem',
    color: '#1F1F1F',
    textAlign: 'center',
  },
  description: {
    fontFamily: 'Lato',
    fontSize: '0.875rem',
    color: '#979797',
    textAlign: 'center',
  },
  cardWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
};

class JamRecipes extends Component {
  renderCard = () => {
    return (
      <Query
        query={gql`
          query {
            templateMany {
              name, 
              _id,
              slug, 
              blurb, 
              parents {
                type, 
                preset {
                  name,
                  slug,
                  _id
                },
                template {
                  name, 
                  slug, 
                  _id
                }
                count
              },
              sessions {
                description, 
                index,
                _id, 
                output {
                  name,
                  slug, 
                  type
                }
              }
            }
          }`}
      >
        {({ loading, error, data }) => {
          if (loading) return <p>Loading...</p>;
          if (error) return <p>Error :(</p>;

          return (
            <Subscribe to={[TemplatesContainer]}>
              { templates => (data.templateMany || templates.mockTemplates).map((template, index) => (
                <JamRecipesCard
                  onClick={() => templates.selectTemplate(template)}
                  key={index}
                  title={template.name}
                  description={template.blurb}
                  number={(index+1)}
                  slug={template.slug}
                />
              )) }
            </Subscribe>
          );
        }}
      </Query>
    );
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.recipesContainer}>
        <HeaderPage titleHeader="Select a Story Jam Recipe" descriptionHeader="Short description of is story jam recipe." showBtns={false} />
        <div className={classes.cardWrapper}>
          {this.renderCard()}
        </div>
      </div>
    );
  }
}

JamRecipes.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default injectSheet(styles)(JamRecipes);



// WEBPACK FOOTER //
// ./src/pages/JamRecipes.js